module.exports = __webpack_public_path__ + "static/media/10.7a321a43.jpg";